  document.addEventListener("DOMContentLoaded", function () {
    // Check if the popup has already been shown in the current session
    if (!sessionStorage.getItem('popupShown')) {
      // Open the popup after 3 seconds if it hasn't been shown yet
      setTimeout(function() {
        document.getElementById('newsletterPopup').style.display = 'flex';
        sessionStorage.setItem('popupShown', 'true'); // Mark the popup as shown
      }, 3000);  // Delay in milliseconds (example: 3 seconds)
    }

    // Close the popup when the close button is clicked
    document.getElementById('closehomePopup').addEventListener('click', function () {
      document.getElementById('newsletterPopup').style.display = 'none';
    });

    // Open the popup when the button is clicked (if needed)
    document.getElementById('openPopup').addEventListener('click', function () {
      document.getElementById('newsletterPopup').style.display = 'flex';
    });

    // Close the popup when clicking outside of the popup content (on the background)
    document.getElementById('newsletterPopup').addEventListener('click', function (e) {
      // If the target is the popup background (not the content), close the popup
      if (e.target === document.getElementById('newsletterPopup')) {
        document.getElementById('newsletterPopup').style.display = 'none';
      }
    });
  });